/**
 * BIMARCA (Tiago, 27-31/08): alugando.com e a casa do PRODUTO (lease-to-own
 * do dominio fechado em 31/08); impostodoaluguel.com.br e a fachada fiscal
 * (calculadora/diagnostico) que joga o lead para o produto. Hierarquia:
 * Alugando.com e a marca unica em todas as fachadas.
 * sistemadoaluguel.com.br ficou como dominio defensivo: se resolver, o app
 * redireciona para a casa.
 *
 * A VIRADA fica desligada ate o dominio novo resolver e o OAuth aceitar o
 * host novo — ligar antes deixaria todo mundo sem login. Quando tudo
 * estiver verde: VIRADA = true e deploy.
 */
export const URL_SISTEMA = "https://alugando.com";

/** Entrada do aplicativo. A raiz do dominio pertence sempre a landing publica. */
export const URL_APP = `${URL_SISTEMA}/painel`;

export const VIRADA = false;

const host = typeof location !== "undefined" ? location.hostname : "";

/**
 * A casa do produto e o PADRAO: alugando.com, web.app (preview) e dev se
 * comportam como ela. So o dominio da isca fiscal fica de fora — assim a
 * home nova e visualizavel em https://impostodoaluguel.web.app antes do
 * DNS do alugando.com apontar.
 */
export const NO_SISTEMA = !host.endsWith("impostodoaluguel.com.br");

/** Dominio defensivo: nunca vira fachada propria, so encaminha. */
export const NO_DEFENSIVO = host.endsWith("sistemadoaluguel.com.br");

/** Fachada-isca: so o dominio fiscal, e so depois da virada. */
export const EH_ISCA = VIRADA && host.endsWith("impostodoaluguel.com.br");

/*
 * A marca visivel e UMA: alugando (31/08, Tiago) — cabecalho, celular da
 * landing e app, em qualquer dominio. A marca fiscal anterior foi retirada.
 */
export const NOME_MARCA = "alugando.com";
